export default __webpack_public_path__ + "static/media/territories.e0a1c847.svg";